import {
  MODULE_FILE_CSV_UPLOAD,
  MODULE_FILE_CSV_UPLOAD_SUCCESS,
  MODULE_FILE_CSV_UPLOAD_ERROR,
  MODULE_AVAILABLE_MODULE_FIELDS,
  MODULE_AVAILABLE_MODULE_FIELDS_SUCCESS,
  MODULE_AVAILABLE_MODULE_FIELDS_ERROR,
  FILE_ATTACHMENT_CREATE_PREAUTH,
  FILE_ATTACHMENT_CREATE_PREAUTH_SUCCESS,
  FILE_ATTACHMENT_CREATE_PREAUTH_ERROR,
} from "./actionType";

const initialData = {
  moduleFileCSVUploadLoading: false,
  moduleFileCSVUploadData: [],
  moduleFileCSVUploadError: null,

  moduleAvailableModuleFieldsLoading: false,
  moduleAvailableModuleFieldsData: [],
  moduleAvailableModuleFieldsError: null,

  fileAttachmentCreatePreauthLoading: false,
  fileAttachmentCreatePreauthData: [],
  fileAttachmentCreatePreauthError: null,
};

const FileUploads = (state = initialData, action) => {
  switch (action.type) {
    case MODULE_FILE_CSV_UPLOAD:
      return {
        ...state,
        moduleFileCSVUploadLoading: true,
      };
    case MODULE_FILE_CSV_UPLOAD_SUCCESS:
      return {
        ...state,
        moduleFileCSVUploadLoading: false,
        moduleFileCSVUploadData: action.payload,
        moduleFileCSVUploadError: null,
      };
    case MODULE_FILE_CSV_UPLOAD_ERROR:
      return {
        ...state,
        moduleFileCSVUploadLoading: false,
        moduleFileCSVUploadData: [],
        moduleFileCSVUploadError: action.payload,
      };
    case MODULE_AVAILABLE_MODULE_FIELDS:
      return {
        ...state,
        moduleAvailableModuleFieldsLoading: true,
      };
    case MODULE_AVAILABLE_MODULE_FIELDS_SUCCESS:
      return {
        ...state,
        moduleAvailableModuleFieldsLoading: false,
        moduleAvailableModuleFieldsData: action.payload,
        moduleAvailableModuleFieldsError: null,
      };
    case MODULE_AVAILABLE_MODULE_FIELDS_ERROR:
      return {
        ...state,
        moduleAvailableModuleFieldsLoading: false,
        moduleAvailableModuleFieldsData: [],
        moduleAvailableModuleFieldsError: action.payload,
      };
    case FILE_ATTACHMENT_CREATE_PREAUTH:
      return {
        ...state,
        fileAttachmentCreatePreauthLoading: true,
      };
    case FILE_ATTACHMENT_CREATE_PREAUTH_SUCCESS:
      return {
        ...state,
        fileAttachmentCreatePreauthLoading: false,
        fileAttachmentCreatePreauthData: action.payload,
        fileAttachmentCreatePreauthError: null,
      };
    case FILE_ATTACHMENT_CREATE_PREAUTH_ERROR:
      return {
        ...state,
        fileAttachmentCreatePreauthLoading: false,
        fileAttachmentCreatePreauthData: [],
        fileAttachmentCreatePreauthError: action.payload,
      };
    default:
      return state;
  }
};

export default FileUploads;
